export default "__VITE_ASSET__BdCzn8NR__"